<template>
  <div class="form-group" :class="newClass">
    <label class="form-group__label" :class="checkRequired" :for="id"
      >{{ label }} <slot name="popover"></slot>
    </label>
    <input
      :type="type"
      class="form-control"
      :class="checkValidation"
      :name="name"
      @input="emit"
      :maxlength="maxLengthing"
      @change="emit"
      :disabled="disabled"
      v-model="val"
      @focus="onFocus"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      val: ""
    };
  },
  computed: {
    checkRequired() {
      return this.required ? "required-label" : "";
    },
    checkValidation() {
      let classes = this.inputClass;

      if (this.isNeedValidation) {
        return (this.val && this.val.length) || typeof this.val === "number"
          ? classes + " valid"
          : classes + " invalid";
      }

      return classes;
    }
  },
  props: {
    required: {
      type: Boolean,
      default: false
    },
    isNeedValidation: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    },
    name: {
      type: String,
      default: "inp"
    },
    type: {
      type: String,
      default: "text"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      default: ""
    },
    id: {
      type: [Number, String]
    },
    newClass: {
      type: String,
      default: "form-group_other"
    },
    inputClass: {
      type: String,
      default: ""
    },
    maxLengthing: {
      type: [Number, String]
    },
    isShowPopover: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onFocus(e) {
      e.target.select();
    },
    emit() {
      if (this.type === "checkbox") {
        this.$emit("change", this.val);
      } else {
        this.$emit("input", this.val);
      }
    }
  },
  watch: {
    value() {
      if (this.value === "null") {
        return "";
      }
      this.val = this.value;
    }
  },
  created() {
    this.val = this.value;
  }
};
</script>

<style lang="scss" scoped>
.form-group__label {
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: var(--main-text-color);
  position: relative;
}

.required-label:after {
  content: "*";
  font-size: 26px;
  color: red;
  position: absolute;
}

.form-control {
  background: var(--auth-input-bg);
  border: 1px solid var(--auth-input-bg);
  box-sizing: border-box;
  border-radius: 6px;
  min-height: 56px;
  color: var(--main-text-color);
}

.form-control.invalid {
  border: 1px rgb(245, 0, 0) solid;
}

.form-control.invalid:focus {
  box-shadow: 0 0 0 3px rgba(245, 0, 0, 0.2);
}

.form-control.valid {
  border: 1px rgb(40, 167, 69) solid;
}

.form-control.valid:focus {
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.2);
}

.push-form__input {
  font-size: 20px;
  line-height: 18px;

  text-align: center;
  letter-spacing: -0.165px;

  color: #58585e;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: var(--auth-input-bg);
  opacity: 1;
}
</style>
